/* Seafood & meat box landing page (page.box-landing): hero carousel, bundle
   filters, review card fitting and the build-a-box builder. Each block finds
   its own section, so sections can be reordered or repeated in the editor. */
(() => {
  /* every nc-box-* section links this file; set up once, then again when the
     theme editor re-renders a section */
  if (window.__ncbxInit) return;
  window.__ncbxInit = true;
  const once = (el) => (el.dataset.ncbxReady ? false : (el.dataset.ncbxReady = '1'));
  const init = () => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (v) => '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  /* The hero fills the first screen under the announcement bar and header. */
  const setTop = () => {
    const hero = document.querySelector('.ncbx .hero');
    if (hero) document.documentElement.style.setProperty('--ncbx-top', Math.max(0, hero.getBoundingClientRect().top + scrollY) + 'px');
  };
  setTop();
  if (!window.__ncbxTop) {
    window.__ncbxTop = true;
    addEventListener('load', setTop);
    addEventListener('resize', setTop);
  }

  /* ---------- hero carousel (stacked deck) ---------- */
  document.querySelectorAll('.ncbx [data-car]').forEach((car) => {
    if (!once(car)) return;
    const dots = car.querySelector('.dots');
    const bar = car.querySelector('.prog i');
    const items = [...car.querySelectorAll('.dk')];
    const n = items.length;
    if (!n) return;
    const DUR = 4500;
    let i = 0;
    let tm = null;
    car.style.setProperty('--dur', DUR + 'ms');
    items.forEach((_, k) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Show bundle ' + (k + 1));
      b.onclick = () => { go(k); play(); };
      dots.appendChild(b);
    });
    function go(k) {
      const prev = i;
      i = (k + n) % n;
      [...dots.children].forEach((d, j) => d.setAttribute('aria-selected', j === i));
      items.forEach((c, j) => {
        const p = (j - i + n) % n;
        c.dataset.pos = p < 4 ? String(p) : '3';
        c.setAttribute('aria-hidden', p !== 0);
        c.querySelectorAll('a,button').forEach((x) => (x.tabIndex = p === 0 ? 0 : -1));
      });
      if (prev !== i) {
        const o = items[prev];
        o.dataset.pos = 'out';
        setTimeout(() => {
          const p = (prev - i + n) % n;
          o.dataset.pos = p < 4 ? String(p) : '3';
        }, 600);
      }
      if (bar) {
        bar.classList.remove('run');
        void bar.offsetWidth;
        if (!RM) bar.classList.add('run');
      }
    }
    function play() {
      clearInterval(tm);
      if (RM || n < 2) return;
      tm = setInterval(() => { if (!car.classList.contains('paused')) go(i + 1); }, DUR);
    }
    car.addEventListener('mouseenter', () => car.classList.add('paused'));
    car.addEventListener('mouseleave', () => { car.classList.remove('paused'); go(i); play(); });
    car.addEventListener('focusin', () => car.classList.add('paused'));
    car.addEventListener('focusout', (e) => { if (!car.contains(e.relatedTarget)) car.classList.remove('paused'); });
    go(0);
    play();
  });

  /* ---------- bundle filter pills ---------- */
  document.querySelectorAll('.ncbx .bundles').forEach((sec) => {
    if (!once(sec)) return;
    const cards = [...sec.querySelectorAll('.bc')];
    const count = sec.querySelector('[data-bcount]');
    sec.querySelectorAll('.pill').forEach((p) => p.addEventListener('click', () => {
      sec.querySelectorAll('.pill').forEach((x) => x.setAttribute('aria-pressed', x === p));
      const c = p.dataset.cat;
      let k = 0;
      cards.forEach((b) => {
        const on = c === 'all' || b.dataset.cats.split(' ').includes(c);
        b.hidden = !on;
        if (on) k++;
      });
      if (count) count.textContent = k;
    }));
  });

  /* ---------- FAQ: one answer open at a time (fallback for browsers without <details name>) ---------- */
  document.querySelectorAll('.ncbx details.fq').forEach((d) => {
    if (!once(d)) return;
    d.addEventListener('toggle', () => {
      if (!d.open || !d.name) return;
      document.querySelectorAll('.ncbx details.fq[name="' + d.name + '"][open]').forEach((o) => { if (o !== d) o.open = false; });
    });
  });

  /* ---------- reviews: clamp each card's quote to the lines that fit ---------- */
  const rvf = [...document.querySelectorAll('.ncbx .rvf')];
  if (rvf.length) {
    // Line pitch as rendered: computed line-height can disagree with what
    // iPad Safari actually draws, which leaves a partial line under the clamp.
    const pitch = (bq) => {
      const r = document.createRange();
      r.selectNodeContents(bq);
      const tops = [];
      [...r.getClientRects()].forEach((x) => { if (!tops.some((t) => Math.abs(t - x.top) < 2)) tops.push(x.top); });
      tops.sort((a, b) => a - b);
      if (tops.length > 2) return (tops[tops.length - 1] - tops[0]) / (tops.length - 1);
      return parseFloat(getComputedStyle(bq).lineHeight) || 22;
    };
    const fit = () => rvf.forEach((s) => {
      const c = s.querySelector('.wc');
      if (!c) return;
      s.classList.toggle('tight', c.clientHeight < 128);
      s.style.setProperty('--lc', 99);
      s.style.removeProperty('--lch');
      const bq = c.querySelector('blockquote');
      const longest = [...s.querySelectorAll('.wc blockquote')].reduce((a, b) => (b.textContent.length > a.textContent.length ? b : a), bq);
      const lh = pitch(longest);
      const n = Math.max(1, Math.floor((bq.getBoundingClientRect().height + 1) / lh));
      s.style.setProperty('--lc', n);
      s.style.setProperty('--lch', n * lh + 'px');
    });
    window.__ncbxFit = fit;
    if (!window.__ncbxRvBound) {
      window.__ncbxRvBound = true;
      addEventListener('resize', () => { clearTimeout(window.__ncbxRv); window.__ncbxRv = setTimeout(() => window.__ncbxFit(), 80); });
    }
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(fit);
    fit();
  }

  /* ---------- build a box ---------- */
  document.querySelectorAll('.ncbx .box').forEach((sec) => {
    if (!once(sec)) return;
    const read = (sel) => { const el = sec.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
    const BOX = read('[data-bx-catalog]') || [];
    const BEST = (read('[data-bx-best]') || []).map(String);
    const CFG = read('[data-bx-config]') || {};
    const grid = sec.querySelector('[data-bx-grid]');
    if (!grid || !BOX.length) return;
    sec.querySelectorAll('.tab [data-tab-count]').forEach((el, k) => { if (BOX[k]) el.textContent = BOX[k].items.length; });
    const $ = (s) => sec.querySelector(s);
    const ship = CFG.ship || 219;
    const bonus = CFG.bonus || 0;
    const goal = bonus > ship ? bonus : ship;
    const disc = (CFG.discount || 0) / 100;

    const ALL = BOX.flatMap((c) => c.items.map((it) => ({ ...it, cat: c.name })));
    const byPid = {};
    ALL.forEach((it) => { if (!byPid[it.pid]) byPid[it.pid] = it; });
    const sel = {}; /* variant id -> {qty, it, v} */
    const pick = {};
    ALL.forEach((it) => (pick[it.pid] = it.vid));
    let tab = 0;
    let q = '';
    const cnt = $('[data-bx-count]');
    const search = $('[data-bx-q]');
    if (search && !search.placeholder) search.placeholder = `Search ${Object.keys(byPid).length} cuts and fish`;
    const vOf = (it, vid) => it.v.find((v) => v.id == vid) || it.v[0];

    function card(it) {
      const v = vOf(it, pick[it.pid]);
      const qn = sel[v.id] ? sel[v.id].qty : 0;
      const opts = it.v.length > 1
        ? `<label class="vh" for="v${it.pid}">Option for ${esc(it.name)}</label><select id="v${it.pid}" data-v="${it.pid}">${it.v.map((x) => `<option value="${x.id}"${x.id == v.id ? ' selected' : ''}${x.a ? '' : ' disabled'}>${esc(x.t)}${x.a ? '' : ' (Sold out)'}</option>`).join('')}</select>`
        : '';
      const ctl = !v.a
        ? '<button type="button" class="add" disabled>Sold out</button>'
        : qn
          ? `<span class="stp"><button type="button" data-dec="${it.pid}" aria-label="Remove one ${esc(it.name)}">&minus;</button><output aria-live="polite">${qn}</output><button type="button" data-inc="${it.pid}" aria-label="Add one more ${esc(it.name)}">+</button></span>`
          : `<button type="button" class="add" data-inc="${it.pid}" aria-label="Add ${esc(it.name)} to your box">Add</button>`;
      return `<article class="it${qn ? ' in' : ''}" data-pid="${it.pid}"><a class="it-img" href="${it.url}" tabindex="-1">${it.img ? `<img src="${it.img}" alt="${esc(it.name)}" width="400" height="400" loading="lazy">` : ''}${qn ? `<span class="qb">${qn}</span>` : ''}</a>
  <div class="it-b"><h3 class="it-n"><a href="${it.url}">${esc(it.name).replace(/ (\S+)$/, ' $1')}</a></h3>${opts}<div class="it-f"><b class="it-p">${money(v.p)}</b>${ctl}</div></div></article>`;
    }
    function list() {
      const s = q.trim().toLowerCase();
      if (s) {
        const seen = new Set();
        return ALL.filter((it) => {
          if (seen.has(it.pid)) return false;
          const m = (it.name + ' ' + it.cat).toLowerCase().includes(s);
          if (m) seen.add(it.pid);
          return m;
        });
      }
      return BOX[tab].items;
    }
    function render() {
      const L = list();
      grid.innerHTML = L.map(card).join('') || `<p class="count">No items match "${esc(q)}". Try salmon, wagyu or uni.</p>`;
      cnt.textContent = q.trim() ? `${L.length} item${L.length === 1 ? '' : 's'} match "${q.trim()}"` : `${L.length} items in ${BOX[tab].full}`;
    }
    function change(pid, d) {
      const it = byPid[pid];
      const v = vOf(it, pick[pid]);
      if (!v.a) return;
      const cur = sel[v.id] ? sel[v.id].qty : 0;
      const nq = Math.max(0, Math.min(99, cur + d));
      if (nq) sel[v.id] = { qty: nq, it, v };
      else delete sel[v.id];
      render();
      summary();
    }
    grid.addEventListener('click', (e) => {
      const a = e.target.closest('[data-inc],[data-dec]');
      if (!a) return;
      const pid = a.dataset.inc || a.dataset.dec;
      change(pid, a.dataset.inc ? 1 : -1);
      const again = grid.querySelector(`[data-pid="${pid}"] ${a.dataset.inc && !a.classList.contains('add') ? '[data-inc]' : a.dataset.dec ? '[data-dec]' : '[data-inc]'}`) || grid.querySelector(`[data-pid="${pid}"] button`);
      if (again) again.focus();
    });
    grid.addEventListener('change', (e) => {
      const s = e.target.closest('[data-v]');
      if (!s) return;
      pick[s.dataset.v] = +s.value;
      render();
    });
    sec.querySelectorAll('.tab').forEach((t) => t.addEventListener('click', () => {
      tab = +t.dataset.tab;
      q = '';
      search.value = '';
      sec.querySelectorAll('.tab').forEach((x) => x.setAttribute('aria-selected', x === t));
      render();
    }));
    search.addEventListener('input', (e) => {
      q = e.target.value;
      sec.querySelectorAll('.tab').forEach((x) => x.setAttribute('aria-selected', !q.trim() && +x.dataset.tab === tab));
      render();
    });
    const sumEl = $('[data-bx-sum]');
    const fill = $('[data-bx-fill]');
    if (fill) fill.addEventListener('click', () => {
      let t = subtotal();
      for (const pid of BEST) {
        if (t >= ship) break;
        const it = byPid[pid];
        if (!it) continue;
        const v = vOf(it, it.vid);
        if (!v.a || sel[v.id]) continue;
        sel[v.id] = { qty: 1, it, v };
        t += v.p;
      }
      render();
      summary();
      sumEl.classList.add('flash');
      setTimeout(() => sumEl.classList.remove('flash'), 900);
    });
    const freqSel = $('[data-bx-freq]');
    const freq = () => (freqSel ? freqSel.value : '');
    if (freqSel) freqSel.addEventListener('change', summary);
    function subtotal() { return Object.values(sel).reduce((t, x) => t + x.qty * x.v.p, 0); }
    function summary() {
      const items = Object.values(sel);
      const n = items.reduce((t, x) => t + x.qty, 0);
      const sub = subtotal();
      const off = freq() ? sub * disc : 0;
      const tot = sub - off;
      $('[data-bx-n]').textContent = n;
      $('[data-bx-pkn]').textContent = n;
      $('[data-bx-pkt]').textContent = money(tot);
      $('[data-bx-list]').innerHTML = items.length
        ? items.map((x) => `<li>${x.it.img ? `<img src="${x.it.img}" alt="" width="44" height="44">` : '<span></span>'}<span><span class="sn">${esc(x.it.name)}${x.it.v.length > 1 ? ' (' + esc(x.v.t) + ')' : ''}</span><span class="sp">${x.qty} &times; ${money(x.v.p)}</span></span><button type="button" class="rm" data-rm="${x.v.id}" aria-label="Remove ${esc(x.it.name)}">Remove</button></li>`).join('')
        : `<li class="empty">${esc(CFG.empty || 'Choose at least 1 item to continue.')}</li>`;
      $('[data-bx-sub]').textContent = money(sub);
      $('[data-bx-save]').textContent = '-' + money(off);
      $('[data-bx-saverow]').hidden = !off;
      $('[data-bx-tot]').textContent = money(tot);
      $('[data-bx-milefill]').style.width = Math.min(100, (tot / goal) * 100) + '%';
      const m = $('[data-bx-milemsg]');
      if (bonus > ship && tot >= bonus) m.innerHTML = `<b>${esc(CFG.msgShipDone || 'Free shipping unlocked.')}</b> ${esc(CFG.msgBonusDone || '')}`;
      else if (tot >= ship) m.innerHTML = `<b>${esc(CFG.msgShipDone || 'Free shipping unlocked.')}</b>${bonus > ship ? ' ' + esc((CFG.msgBonusLeft || 'Add [amount] more.').replace('[amount]', money(bonus - tot))) : ''}`;
      else m.innerHTML = esc(CFG.msgShipLeft || 'Add [amount] more for free standard shipping.').replace('[amount]', `<b>${money(ship - tot)}</b>`);
      const perk = $('[data-bx-perk]');
      if (perk) perk.classList.toggle('on', !!freq());
      const go = $('[data-bx-go]');
      go.disabled = !n;
      go.textContent = freq() ? CFG.subscribeLabel || 'Subscribe to This Box' : CFG.addLabel || 'Add Box to Cart';
    }
    $('[data-bx-list]').addEventListener('click', (e) => {
      const r = e.target.closest('[data-rm]');
      if (!r) return;
      delete sel[r.dataset.rm];
      render();
      summary();
    });
    const go = $('[data-bx-go]');
    const err = $('[data-bx-err]');
    go.addEventListener('click', async () => {
      const items = Object.values(sel);
      if (!items.length) return;
      /* Subscriptions run through Recharge on the existing box builder product. */
      if (freq()) { if (CFG.subUrl) location.href = CFG.subUrl; return; }
      go.disabled = true;
      if (err) err.hidden = true;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map((x) => ({ id: x.v.id, quantity: x.qty })) }),
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j.description || j.message || 'Could not add your box to the cart.');
        }
        location.href = root + 'cart';
      } catch (e) {
        go.disabled = false;
        if (err) { err.textContent = e.message; err.hidden = false; }
      }
    });
    const peek = sumEl.querySelector('.bx-peek');
    peek.addEventListener('click', () => {
      const o = sumEl.classList.toggle('open');
      peek.setAttribute('aria-expanded', o);
      peek.querySelector('.pk-v').textContent = o ? 'Hide box' : 'View box';
    });
    render();
    summary();
  });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
